import { LinearProgress } from '@mui/material'
import { useDispatch, useSelector } from '@tabeeb/store'
import { ChangeEvent } from 'react'
import activitiesSelector from '../../selectors'
import { onEnterSearchTextFilter } from '../../actions'
import { getIsTextSearchDisabled } from '../../services/activityHelper'

import './styles.less'

const SearchFilter = () => {
  const dispatch = useDispatch()

  const { searchFilter, activityType } = useSelector(activitiesSelector.getActivitiesFilter)
  const isSearchInProgress = useSelector(activitiesSelector.getSearchInProgress)

  const handleChangeSearchFilter = (e: ChangeEvent<HTMLInputElement>) => {
    const newSearchFilter = e.target.value

    if (newSearchFilter !== searchFilter) {
      dispatch(onEnterSearchTextFilter(newSearchFilter))
    }
  }

  return (
    <div className='searchActivitiesFilter'>
      <input
        disabled={getIsTextSearchDisabled(activityType)}
        type='text'
        maxLength={100}
        className='searchActivities'
        placeholder='Search Activities'
        onChange={handleChangeSearchFilter}
        value={searchFilter}
      />
      {isSearchInProgress && <LinearProgress />}
    </div>
  )
}

export default SearchFilter
